import { BuyOrderModelType } from '@teinor/erp/types/company/order/buy/buyOrder'
import ITHeaderText, { ITHeaderTextSupplier } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import { displayDate } from '../../../../../../../utils/globals/date'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { BuyTagsPayload } from '../../../../../../../utils/reducers/buys/buyTags'
import { getActiveCurrenciesDictionary } from '../../../../../../../utils/reducers/getters'
import { parseAddressToOneLine } from '../../../../../../../utils/globals/address'
import { OrderHeaderURLs } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { ITHeaderOrderTags } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderOrderTags'

type BuyStepHeaderMainNoPermissionProps = InputTableLeftTabsProps & {
    orderHeaderURLs: OrderHeaderURLs
    buyTags: BuyTagsPayload
}

const BuyStepHeaderMainNoPermission: React.FC<BuyStepHeaderMainNoPermissionProps> = ({ handleChange, headerData, buyTags, setCompleteData }) => {
    const { t } = useTwinTranslation()
    const activeCurrencies = getActiveCurrenciesDictionary()

    let extraFields: FormElement<keyof BuyOrderModelType>[] = []
    if (headerData.CustomerId) {
        extraFields.push({
            name: 'CustomerId',
            component: 'Custom',
            render: () => <ITHeaderText label={t('customer', 'Cliente')} value={headerData?.Customer?.name} className={returnClassOfSpanTemplate(3)} />
        },)
    }
    const sections: FormRender<BuyOrderModelType> = [
        {
            cols: 5,
            elements: [
                 {
                    name: 'SupplierId',
                    component: 'Custom',
                    render: () => <ITHeaderTextSupplier label={t('supplier', 'Proveedor')} headerData={headerData} className={returnClassOfSpanTemplate(5)} />
                },
                ...extraFields,
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('representative', 'Representante')} value={headerData?.RepresentativeEmployee?.fullname_short} className={returnClassOfSpanTemplate(5)} />
                },
                {
                    name: 'processed_date',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('dateBuyOrder', 'Fecha de la compra')} value={displayDate(new Date(value))} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('assignedNumber', 'Nº asignado')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA') + ' ' + returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'supplier_number_order',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('supplierNumberOrderS', 'Nº Prov.')} value={value} className={returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'supplier_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('supplierInvoiceS', 'Fact. proveedor')} value={value} className={returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'supplier_date',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('dateSupplier', 'Fecha del proveedor')} value={value ? displayDate(new Date(value)) : ''} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('billedBy', 'Facturado por')} value={headerData?.BillingWorkingCenter?.name || ''} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} className={returnClassOfSpanTemplate(2)} />
                    }
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('buyedBy', 'Comprado por')} value={headerData.WorkingCenter.name || ''} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'BillingAddressId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('workingCenterAddress', 'Dirección centro de trabajo')} value={parseAddressToOneLine(headerData?.BillingWorkingCenter)
                        } className={returnClassOfSpanTemplate(5)} />
                    },
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('currency', 'Moneda')} value={activeCurrencies?.[value]?.name} className={returnClassOfSpanTemplate(5)} />
                },
                {
                    name: 'OrderTags',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return (<ITHeaderOrderTags readOnly={true} selectedTags={extraProps.selectedTags} dictTags={buyTags} headerData={headerData} onChange={handleChange} setCompleteData={setCompleteData} className={returnClassOfSpanTemplate(5)} />)
                    },
                    extraProps: { selectedTags: headerData?.tags }
                },
            ]
        }
    ]
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData} />
    )
}


export default BuyStepHeaderMainNoPermission